import React, { useState, useContext, useEffect, useRef } from "react";
import { useUserSession } from './lib/session/UserSession';
import { Card, CardBody, CardHeader, Tabs, Tab, Typography } from '@material-tailwind/react';
import DialogAlert from "./demo/platform/DialogAlert";
import InfoManager from "./components/organizer/infoManager/App";
import SessionData from "./lib/session/sessionData.json";
import MaintenanceDialog from "./demo/platform/MaintenanceDialog"
import {
  ApplicationContainer,
  AppDataFetcher,
  AppUtils,
  ApplicationContextStoreProvider,
  ClientMediator
} from '@8d-xyz/ui-react_application_f-container';
import eventDispatcher from "./events/dispatcher";
import NavWidget from "./components/containers/NavWidget"
import BarWidget from "./components/containers/BarWidget"
import Footer from "./components/common/Footer";
import MobileFooter from "./components/common/MobileFooter";
import { IconSelector } from "./components/organizer/common/IconSelector";
import LoginDialog from './demo/platform/AuthorizationDialog';

import LoadingDialog from "./demo/platform/WaitDialog";
import AnnouncementBanner from "./demo/platform/AnnouncmentBanner";

import ToastManager from "./demo/platform/ToastManager"
import SiteAnnouncement from "./demo/platform/SiteAnnouncement"
import { useNavigate } from "react-router-dom";


import {
  Tree,
  MultiBackend,
  getBackendOptions,
  DndProvider,
  getDescendants,
  isAncestor,
  hasChildNodes,
} from "@minoru/react-dnd-treeview";

const {
  publishEvent,
  broadcastEvent,
  listenForEvent,
  getEventConfig,
  setEventConfig,
  startMediator } = ClientMediator;

const ApplicationModalWidgetAlert = () => {
  let applicationModalPanelContainerAPIs = AppUtils.getAPIs("ApplicationContainer").ModalPanel;
  return <DialogAlert
    apis={applicationModalPanelContainerAPIs}
    modalConfig={promptMessage}
    onClose={() => {
      applicationModalPanelContainerAPIs.closeOpen.exec(false);
    }} />
};


const adWidgetL = () => {
  return <></>

};
const adWidgetR = () => {
  //return <div className="bg-red-300 flex flex-grow items-center justify-center h-full" />
  return <div />
};

const adWidgetT = () => {
  const { user, logout, login, sessionData, setSessionStore, sessionStore } = useUserSession();
  //return <div className="bg-orange-300 w-full flex-grow flex flex-col h-20" />
  return <div> {sessionStore.APP_META.RUNTIME.ANNOUNCEMENT.STATE === "RUNNING" &&
    <AnnouncementBanner
      title={sessionStore.APP_META.RUNTIME.ANNOUNCEMENT.TITLE}
      message={sessionStore.APP_META.RUNTIME.ANNOUNCEMENT.MESSAGE}
      severity={sessionStore.APP_META.RUNTIME.ANNOUNCEMENT.SEVERITY}// info, warning, error, success
    />}
  </div>
};
const adWidgetB = () => {
  //return <div className=" bg-green-300 flex items-center justify-center flex-grow h-full" />;
  return <div />;
};

const ApplicationBarWidget = () => {
  const { user, logout, login, sessionData, setTagEntities } = useUserSession();
  return user ? <BarWidget /> : <NavWidget />
};





function useIsMobileReal() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
      const smallScreen = Math.max(window.innerWidth, window.innerHeight) <= 820; // covers most phones
      setIsMobile(smallScreen);
    };

    check(); // Initial
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}

const AuxiliaryWidget = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { user, logout, login, sessionData } = useUserSession();
  const [tabs, setTabs] = useState(user ? user.APP_TABS : []);
  const containerRef = useRef(null); 

  return (
    <div className="flex flex-grow bg-gray-100">
      {user && (
        <DndProvider backend={MultiBackend} options={getBackendOptions()}>
          <Card className="flex flex-grow rounded-none bg-gray-100">
            <Tabs
              value={selectedTab}
              onChange={(index) => setSelectedTab(index)}
              className="rounded-t-lg flex border-b ml-4 mr-4 mt-2 mb-1 border-b  border-gray-300 min-w-[200px]"     
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  value={index}
                  className="capitalize flex-1 text-center bg-gray-100 border-gray-300"
                  onClick={() => setSelectedTab(index)}
                >
                  <div className="flex items-center justify-center">
                    {IconSelector(tab.id, 'TABS', selectedTab === index)}
                    <Typography className="ml-2">{tab.label}</Typography>
                  </div>
                </Tab>
              ))}
            </Tabs>

            {/* Tab content */}
            <div ref={containerRef} className="flex flex-grow ml-4 mr-4 bg-gray-300 h-[10px] min-w-[200px]"
              style={{
                backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url('/digital.webp')",
              }}>
              {tabs.map((tab, index) => {

                if (selectedTab === index) return (
                  <div
                    key={tab.id}
                    className={`w-full h-[${containerRef.current?.clientHeight * 10}px] overflow-auto`}
                  > <InfoManager
                      nodes={eventDispatcher.GET_ORGANIZER_BY_TYPE(tab.id, {}, () => { })}
                    />
                  </div>
                )
              })}
           
            </div>
            {/* {!useIsMobileReal() && <Footer className="hidden sm:flex" /> } */}
               {/* <Footer className="hidden sm:flex" /> */}
                 {/* <Footer  /> */}
            {useIsMobileReal() && <MobileFooter className="" /> }
            {!useIsMobileReal() && <Footer className="" /> } 
          </Card>
        </DndProvider>
      )}
    </div>
  );
};



const MainPanelWidget = () => {
  const [eventMessage, setEventMessage] = useState("");
  const { user, logout, login, sessionData, setSessionStore, sessionStore } = useUserSession();
  const [access, setAccess] = useState(
    sessionStore.APP_META.RUNTIME.AUTHORIZATION_REQUIRED ?
      (sessionStore.ACCESS ?
        sessionStore.ACCESS : false)
      : true);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!user) {
      containerAPIs.LeftPanel.closeOpen.exec(false);
      containerAPIs.TopPanel.closeOpen.exec(false);
      containerAPIs.AuxPanel.closeOpen.exec(false);
      containerAPIs.AppBarPanel.closeOpen.exec(true);
      containerAPIs.BottomPanel.closeOpen.exec(false);
      containerAPIs.RightPanel.closeOpen.exec(false);
    } else {
      containerAPIs.RightPanel.closeOpen.exec(false);
      containerAPIs.AuxPanel.closeOpen.exec(true);
      containerAPIs.MainPanel.closeOpen.exec(false);
      containerAPIs.BottomPanel.closeOpen.exec(false);
      SessionData.USER_PROFILE.uid = user.uid;
    }

    containerAPIs.TopPanel.closeOpen.exec(true); // optional: this could go in separate effect if needed
  }, [user]); //run only when `user` changes

  const handleLogin = async values => {
    await eventDispatcher.ACCESS_AUTHEN(values, (data) => {
      sessionStore.ACCESS = true;
      setAccess(true);
      setSessionStore(() => { return { ...sessionStore } })
    }, setIsLoading);
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return; // prevent close on backdrop click
    sessionStore.ACCESS = true;
    setAccess(true);
    setSessionStore(() => { return { ...sessionStore } })
  };
  // ClientMediator.listenForEvent(`MP_S-APP-IN_MAINTENANCE`, async (data) => {
  //   //under mantenance refresh page
  //   sessionStore.APP_META.RUNTIME.STATUS="MAINTENANCE";
  //   setSessionStore({ ...sessionStore });

  // });

  let containerAPIs = AppUtils.getAPIs("ApplicationContainer");

  return (

    <div className="bg-[#fcfcfc]  h-full w-full p-0 overflow-none flex-grow flex">
      <div className="bg-[#fcfcfc] min-h-screen p-0" style={{
        height: '100vh',
        width: '100%',
      }}>

        {!user && (AppUtils.getRouteContext().context)}

        <LoadingDialog open={isLoading} message="Authorizing, please wait..." />
        <LoginDialog open={!access} onClose={() => handleClose} onSubmit={handleLogin} />
        {sessionStore.APP_META.RUNTIME.STATUS !== "ACTIVE" && <MaintenanceDialog />}
      </div>
    </div>
  );
};

const loadWidgets = () => {
  let applicationWidgets = AppUtils.getAppWidgets("ApplicationContainer")?.containers;
  applicationWidgets.AdContainers.Left = adWidgetL;
  applicationWidgets.AdContainers.Right = adWidgetR;
  applicationWidgets.AdContainers.Top = adWidgetT;
  applicationWidgets.AdContainers.Bottom = adWidgetB;
  applicationWidgets.ApplicationBarContainer.ApplicationBarPanelContainer = ApplicationBarWidget;
  applicationWidgets.MainContainer.AuxiliaryPanelContainer = AuxiliaryWidget;
  applicationWidgets.MainContainer.MainPanelContainer = MainPanelWidget;
  applicationWidgets.ApplicationModalContainer.ApplicationModalPanelContainer = ApplicationModalWidgetAlert;
  return applicationWidgets;
}
export const appInit = () => {
  loadWidgets();
  let mediatorConfig = AppUtils.getAppConfigs("Mediator");
  if (mediatorConfig.enabled) {
    loadMediator();
  }

}
const loadMediator = () => {
  let mediatorConfig = AppUtils.getAppConfigs("Mediator");
  AppUtils.getAppContextNodeByCat("app_context").ApplicationContext["clientMediator"] = ClientMediator;
  setEventConfig(mediatorConfig.configs);
  startMediator(true);
}

